import { render, staticRenderFns } from "./addGroupDialog.vue?vue&type=template&id=c5aadf3a&scoped=true"
import script from "./addGroupDialog.vue?vue&type=script&lang=js"
export * from "./addGroupDialog.vue?vue&type=script&lang=js"
import style0 from "./addGroupDialog.vue?vue&type=style&index=0&id=c5aadf3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5aadf3a",
  null
  
)

export default component.exports